import { SOCIALS } from "../../data/portfolioData";
import { SOCIAL_ICONS } from "./Icons";

const Socials = ({
  containerStyles = "flex gap-6",
  iconStyles = "w-9 h-9 border border-accent rounded-full flex justify-center items-center text-accent hover:bg-accent hover:text-primary transition-all duration-500",
}) => (
  <div className={containerStyles}>
    {SOCIALS.map(({ name, icon, url }) => {
      const Icon = SOCIAL_ICONS[icon];
      return (
        <a
          key={name}
          href={url}
          target={url.startsWith("http") ? "_blank" : undefined}
          rel="noopener noreferrer"
          aria-label={name}
          title={name}
          className={iconStyles}
        >
          <Icon size={16} />
        </a>
      );
    })}
  </div>
);

export default Socials;
